<template>
  <div style="width: 100%; padding-top: 15px;">
    <template v-if='statusGeral !== ""'>
      <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else-if='statusGeral === "" && Object.keys(tabela).length >= 1'>
      <div class="rf-titulo-tela" v-if='tabela.status === ""'>
        Configurações iniciais para envio dos Documentos Fiscais:
      </div>
      <!-- CRIA A TABELA -->
      <span v-show='false' v-html='time'></span>    
      <div style="width: 75%; margin: 20px auto;" v-if='Object.keys(tabela).length >= 1 && time !== ""'>
        <RF-Tabela style='overflow-x: auto;'
          :cpntTime='time'
          :cpntId='tabela.id'
          :cpntStatus='tabela.status'
          :cpntButtonImprimir='tabela.acoes.btImprimir'
          :cpntButtonAtualizar='tabela.acoes.btAtualizar'
          :cpntFraseTop='tabela.fraseTop'
          :cpntColuna='tabela.coluna'
          :cpntLinha='tabela.linha'
          :cpntCountAll='tabela.countAll'
          :cpntColspan='tabela.colspan'
          :cpntButtonsAcoes='tabela.acoes.buttons'
          :cpntMper='tabela.mper'
          :cpntPagina='tabela.pagina'
          :cpntCheckboxEditar='tabela.checkboxEditar'

          :cpntOnRefreshTabela='iniciarTabela'
          :ref='tabela.id'
        ></RF-Tabela>
      </div>

      <div class='rf-button-form'>
        <RF-Button v-for='(button, index) in buttons' :key="index"
          :cpntId='tabela.id + "-bt-" + index' 
          :cpntStatus='""' 
          :cpntTexto='button.texto' 
          :cpntClass='button.class' 

          @onClickButton='button.onClick()'
        ></RF-Button>
      </div>
    </template>
  </div>
</template>

<style scoped>
  .rf-button-form {
    text-align: center;
  }
  .rf-titulo-tela {
    margin: 20px; 
    font-size: var(--font-base-soma-18);
    text-align: center;
  }
</style>

<style>
  #tab-dfConfig > tbody > tr > td {
    font-size: var(--font-base-soma-18);
    color: var(--color-base-03);
  }
    #tab-dfConfig > tbody > tr > td.tab-dfConfig-td-DocModelo {
      text-align: left;
    }
    #tab-dfConfig > tbody > tr > td.tab-dfConfig-td-DocProxN {
      max-width: 300px;
      color: #ff0000 !important;
    }
    #tab-dfConfig > tbody > tr > td.tab-dfConfig-td-DocNumero > div > input, #tab-dfConfig > tbody > tr > td.tab-dfConfig-td-DocSerie > div > input {
      text-align: center;
    }
</style>

<script>
  export default {
    name: 'RF-Doc-Fiscal-Config-Tabela',
    data: function () {
      return {
        time: '',
        statusGeral: '',
        tabela: {},
        buttons: {},
        formDataTab: []
      }
    },
    mounted: function () {
      if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 20, 23, 25 ], 'or', null, null, null, null, true) === true) {
        this.iniciarTela()
      }
    },
    methods: {
      // FUNÇÕES RELACIONADAS A INICIALIZAÇÃO DA TELA
      // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
      iniciarTela: function () {
        // SETA O STATUS
        this.statusGeral = 'carregando'

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // REALIZA A BUSCA DAS CATEGORIAS EXISTENTES PARA O SELETOR
        this.iniciarTabela()
      },

      iniciarTabela: function () {
        var self = this

        // SETA O STATUS PARA TABELA
        self.statusGeral = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // LIMPA OS CAMPOS PARA SEREM INICIANDO NOVAMENTE
        self.tabela = {
          status: 'carregando',
          id: 'dfConfig',
          api: {
            router: '/df/config/get',
            model: 'dfConfig',
            queryGet: false
          },
          acoes: {
            btImprimir: false,
            btAtualizar: true
          },
          mper: {
            field: false,
            rpp: false,
            order: false
          }
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // INFORMA TODAS AS COLUNAS DA TABELA
        this.tabela.colunaAll = [
          { mPer: 3, chave: 'DocModelo', nome: 'Documento' },
          { mPer: 3, chave: 'tpAmb', nome: 'Ambiente' },
          { mPer: 3, chave: 'DocNumero', nome: 'Último número emitido' },
          { mPer: 3, chave: 'DocSerie', nome: 'Série' },
          { mPer: 3, chave: 'DocProxN', nome: 'Próximo Nº' },
          // { mPer: 3, chave: '_email', nome: 'Enviar por e-mail', explica: { mensagem: 'Marque sim, quando você deseja que o sistema envie automaticamente por e-mail quando a nota fiscal for autorizada.' } }
        ]

        // FAZ A MONTAGEM DAS INFORMAÇÕES PARA TABELA
        self.$store.state.FUN_TABELA_CRIAR_DADOS(JSON.parse(JSON.stringify(self.tabela)), function (tabelaSuccess) {
          // SETA OS DADOS RECEBIDOS PARA TABELA
          self.tabela = tabelaSuccess

          var mostraButton = false
          var aOptions = []

          for (var v = 1; v <= 100; v++) {
            aOptions.push({ value: v })
          }

          for (var key in self.tabela.linha) {
            if (self.tabela.linha[key].tpAmb === 1 || self.tabela.linha[key].tpAmb === '1') {
              self.tabela.linha[key].tpAmb = 'Produção'
            } else if (self.tabela.linha[key].tpAmb === 2 || self.tabela.linha[key].tpAmb === '2') {
              self.tabela.linha[key].tpAmb = 'Homologação'
            }

            if (self.tabela.linha[key].editavel === '1') {
              mostraButton = true

              if (self.tabela.linha[key].DocNumero === null) {
                self.tabela.linha[key].DocNumero = ''
              }

              if (self.tabela.linha[key].DocSerie === null) {
                self.tabela.linha[key].DocSerie = ''
              }
              // tab-ven-pro--0--rf-edicao-qtde--0
              self.tabela.linha[key].DocNumero = [
                {
                  status: '',
                  tamanho: 3,
                  id: self.tabela.id + '--' + key + '--DocNumero--' + 0,
                  tipo: 'input',
                  nome: '',
                  value: self.tabela.linha[key].DocNumero,
                  valueIni: self.tabela.linha[key].DocNumero,
                  apiEnv: 'doc_numero',
                  mensagem: '',
                  mensagemTipo: '',
                  mostrar: true,
                  onChange: function (value, id) {
                    self.onChangeValueTabela(id, value)
                  }
                }
              ]

              if (self.tabela.linha[key].DocModelo === 'NFSe') {
                self.tabela.linha[key].DocSerie = [
                  {
                    status: '',
                    tamanho: 3,
                    id: self.tabela.id + '--' + key + '--DocSerie--' + 0,
                    tipo: 'input',
                    nome: '',
                    value: self.tabela.linha[key].DocSerie,
                    valueIni: self.tabela.linha[key].DocSerie,
                    apiEnv: 'doc_serie',
                    mensagem: '',
                    mensagemTipo: '',
                    mostrar: true,
                    onChange: function (value, id) {
                      self.onChangeValueTabela(id, value)
                    }
                  }
                ]
              } else {
                self.tabela.linha[key].DocSerie = [
                  {
                    status: '',
                    tamanho: 3,
                    id: self.tabela.id + '--' + key + '--DocSerie--' + 0,
                    tipo: 'select2',
                    nome: '',
                    value: self.tabela.linha[key].DocSerie,
                    valueIni: self.tabela.linha[key].DocSerie,
                    keyValue: 'value',
                    keyMostra: [ 'value' ],
                    options: aOptions,
                    apiEnv: 'doc_serie',
                    mensagem: '',
                    mensagemTipo: '',
                    mostrar: true,
                    onChange: function (value, id) {
                      self.onChangeValueTabela(id, value)
                    }
                  }
                ]
              }
            }

            self.tabela.linha[key]._email = [
              {
                status: '',
                tamanho: 3,
                id: self.tabela.id + '--' + key + '--_email--' + 0,
                tipo: 'toggles',
                nome: '',
                value: true,
                apiEnv: 'email',
                mensagem: '',
                mensagemTipo: '',
                disabled: self.tabela.linha[key].DocModelo !== 'NFSe',
                mostrar: true,
                onChange: function (value, id) {
                  self.onChangeValueTabela(id, value)
                }
              }
            ]
          }

          if (mostraButton === true) {
            // CRIA O BOTÃO ENVIAR DO FORMULARIO
            self.buttons.enviar = {
              status: '',
              texto: 'Salvar',
              class: [ 'btn', 'btn-primary' ],
              onClick: self.comunicaPutTab
            }
          }

          // CHAMA A FUNÇÃO PARA FINALIZAR A TABELA
          self.finalizarTabela()
        }, function (tabelaError) {
          // SETA OS DADOS RECEBIDOS PARA TABELA
          self.tabela.status = tabelaError

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()
        })
      },
      finalizarTabela: function () {
        // SETA O STATUS PARA TABELA
        this.tabela.status = ''

        // SETA O TIME PARA FORÇA A ATUALIZAÇÃO DO COMPONENT
        this.time = new Date().getTime()
      },
      onChangeValueTabela: function (id, value) {
        // PEGA O NOME DO CAMPO QUE ESTA SENDO ALTERADO
        var index = id.split('--')

        // SETA O VALOR RECEBIDO
        this.tabela.linha[index[1]][index[2]][index[3]].value = value

        // REMOVE A MENSAGEM DE ERRO
        this.tabela.linha[index[1]][index[2]][index[3]].mensagem = ''
        this.tabela.linha[index[1]][index[2]][index[3]].mensagemTipo = ''

        // PEGA O MODELO DA NOTA
        var tipo = this.tabela.linha[index[1]].DocModelo

        // VERIFICA SE EXISTE O MODELO
        if ([ '', null, undefined ].indexOf(this.formDataTab[tipo]) !== -1) {
          this.formDataTab[tipo] = {}
        }
        
        // SETA O VALOR INFORMADO
        this.formDataTab[tipo].doc_modelo = this.tabela.linha[index[1]].DocModelo
        this.formDataTab[tipo].doc_numero = this.tabela.linha[index[1]].DocNumero[0].value
        this.formDataTab[tipo].doc_serie = this.tabela.linha[index[1]].DocSerie[0].value

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      // montaPutRegistros: function () {
      //   var self = this

      //   self.formDataTab = []

      //   for (var key in self.tabela.linha) {
      //     var put = {}

      //     // VERIFICA SE DEVE ALTERAR O CAMPO SERIE
      //     if (typeof self.tabela.linha[key].DocSerie === 'object' && self.tabela.linha[key].DocSerie[0].value !== self.tabela.linha[key].DocSerie[0].valueIni) {
      //       put[self.tabela.linha[key].DocSerie[0].apiEnv] = self.tabela.linha[key].DocSerie[0].value
      //     }

      //     // VERIFICA SE DEVE ALTERAR O CAMPO NUMERO INICIAL
      //     if (typeof self.tabela.linha[key].DocNumero === 'object' && self.tabela.linha[key].DocNumero[0].value !== self.tabela.linha[key].DocNumero[0].valueIni) {
      //       put[self.tabela.linha[key].DocNumero[0].apiEnv] = self.tabela.linha[key].DocNumero[0].value
      //     }

      //     // VERIFICA SE TEM QUE INFORMAR O CAMPO EMAIL
      //     if (Object.keys(put).length >= 1) {
      //       put.email = [ 's', 'true', true, '1', 1 ].indexOf(self.tabela.linha[key]._mail[0].value) === -1 ? 'S' : 'N'
      //     }

      //     if (Object.keys(put).length >= 1) {
      //       // SETA O MODELO DO DOCUMENTO
      //       put.doc_modelo = self.tabela.linha[key].DocModelo

      //       self.formDataTab.push(put)
      //     }
      //   }

      //   // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      //   self.time = new Date().getTime()

      //   // CHAMA A FUNÇÃO PARA COMUNICAR COM A API
      //   self.comunicaPutTab()
      // },
      comunicaPutTab: function (indexF = 0) {
        var self = this

        // INICIA O VETOR
        if ([ '', null, undefined ].indexOf(indexF) !== -1 || typeof indexF !== 'number') {
          indexF = 0
        }

        // SETA A CHAVE QUE DEVE UTILIZAR
        var chave = Object.keys(self.formDataTab).length >= indexF ? Object.keys(self.formDataTab)[indexF] : ''

        if ([ '', null, undefined ].indexOf(self.formDataTab[chave]) !== -1) {
          // APRESENTA MENSAGEM
          self.$store.state.msgWarn('WEB [200]: Informações atualizadas com sucesso.', 'success')

          // FORÇA A ATUALIZAÇÃO DOS COMPONENTS
          self.time = new Date().getTime()

          // CHAMA A FUNÇÃO PARA ATUALIZAR OS TOTAIS DA VENDA
          self.iniciarTabela()
        } else {
          // MONTA O FORMULARIO QUE SERÁ ENVIADO PARA API
          var formData = self.formDataTab[chave]

          // ENVIA OS DADOS PARA API
          self.$store.state.comunicaAPI('/df/config', 'PUT', formData, function () {  
            // SETA O TIME PARA FORÇA A ATUALIZAÇÃO DO COMPONENT
            self.time = new Date().getTime()

            // CHAMA A FUNÇÃO PARA CONTINUAR A COMUNICAÇÃO
            self.comunicaPutTab((indexF + 1))
          }, function (apiError) {
            // SETA O ERRO RECEBIDO
            self.tabela.status = apiError

            // SETA O TIME PARA FORÇA A ATUALIZAÇÃO DO COMPONENT
            self.time = new Date().getTime()
          }, function (apiValid) {
            // VERIFICA QUAL É A LINHA QUE DEU PROBLEMA
            var index = self.tabela.linha.findIndex(item => item.DocModelo === formData.doc_modelo)

            // VERIFICA SE EXISTE ERRO PARA DOCUMENTO
            if ([ '', null, undefined ].indexOf(apiValid.doc_numero) === -1) {
              self.tabela.linha[index].DocNumero[0].mensagem = apiValid.doc_numero.join()
              self.tabela.linha[index].DocNumero[0].mensagemTipo = 'error'
            }

            // VERIFICA SE EXISTE ERRO PARA SERIE
            if ([ '', null, undefined ].indexOf(apiValid.doc_serie) === -1) {
              self.tabela.linha[index].DocSerie[0].mensagem = apiValid.doc_serie.join()
              self.tabela.linha[index].DocSerie[0].mensagemTipo = 'error'
            }
          })
        }
      }
        
      /*
      // FUNÇÕES RELACIONADAS A INICIALIZAÇÃO DA TABELA
      // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
      iniciarTabela: function () {
        // SETA O STATUS PARA TABELA
        this.tabela.status = 'carregando'

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // SETA A ROTA DE BUSCA NA API
        this.tabela.getApi = '/df/config/get'

        // SETA O ID DA TABELA
        this.tabela.id = 'dfConfig'

        // SETA SE O BOTÃO ATUALIZAR DEVE APARECER
        this.tabela.buttonAtualizar = true

        // SETA SE O BOTÃO IMPRIMIR DEVE APARECER
        this.tabela.buttonImprimir = false

        // INFORMA TODAS AS COLUNAS DA TABELA
        this.tabela.colunaAll = [
          { mPer: 3, tipo: 'texto', chave: 'DocModelo', nome: 'Documento' },
          { mPer: 3, tipo: 'texto', chave: 'tpAmb', nome: 'Ambiente' },
          { mPer: 3, tipo: 'texto', chave: 'DocNumero', nome: 'Último número emitido' },
          { mPer: 3, tipo: 'texto', chave: 'DocSerie', nome: 'Série' },
          { mPer: 3, tipo: 'texto', chave: 'DocProxN', nome: 'Próximo Nº' }
        ]

        // SETA QUE NÃO SERÁ UTILIZADO O QUERY GET
        this.tabela.queryGet = false

        // REALIZA A COMUNIÇÃO COM A API
        getMinhaPersonalizacao(this.tabela, this.finalizarTabela)
      },
      finalizarTabela: function (tabela) {
        this.tabela = tabela

        if (this.tabela.status === 'carregando') {
          var mostraButton = false

          this.tabela.countAll = 3

          var aOptions = []
          for (var v = 0; v <= 899; v++) {
            aOptions.push({ value: v })
          }

          for (var key in this.tabela.linha) {
            if (this.tabela.linha[key].tpAmb === 1 || this.tabela.linha[key].tpAmb === '1') {
              this.tabela.linha[key].tpAmb = 'Produção'
            } else if (this.tabela.linha[key].tpAmb === 2 || this.tabela.linha[key].tpAmb === '2') {
              this.tabela.linha[key].tpAmb = 'Homologação'
            }

            if (this.tabela.linha[key].editavel === true) {
              mostraButton = true

              if (this.tabela.linha[key].DocNumero === null) {
                this.tabela.linha[key].DocNumero = ''
              }

              if (this.tabela.linha[key].DocSerie === null) {
                this.tabela.linha[key].DocSerie = ''
              }

              this.tabela.linha[key].DocNumero = {
                status: '',
                tamanho: 3,
                id: '--DocNumero--' + this.tabela.linha[key].DocModelo,
                tipo: 'input',
                nome: '',
                value: this.tabela.linha[key].DocNumero,
                api: 'DocNumero',
                mensagem: '',
                mensagemTipo: '',
                mostrar: true
              }

              if (this.tabela.linha[key].DocModelo === 'NFSe') {
                this.tabela.linha[key].DocSerie = {
                  status: '',
                  tamanho: 3,
                  id: '--DocSerie--' + this.tabela.linha[key].DocModelo,
                  tipo: 'input',
                  nome: '',
                  value: this.tabela.linha[key].DocSerie,
                  api: 'DocSerie',
                  mensagem: '',
                  mensagemTipo: '',
                  mostrar: true
                }
              } else {
                this.tabela.linha[key].DocSerie = {
                  status: '',
                  tamanho: 3,
                  id: '--DocSerie--' + this.tabela.linha[key].DocModelo,
                  tipo: 'select2',
                  nome: '',
                  value: this.tabela.linha[key].DocSerie,
                  keyValue: 'value',
                  keyMostra: [ 'value' ],
                  options: aOptions,
                  api: 'DocSerie',
                  mensagem: '',
                  mensagemTipo: '',
                  mostrar: true
                }
              }
            }
          }

          if (mostraButton === true) {
            // CRIA O BOTÃO ENVIAR DO FORMULARIO
            this.buttons.enviar = {
              status: '',
              texto: 'Salvar',
              class: [ 'btn', 'btn-primary' ]
            }
          }

          // SETA O STATUS PARA TABELA
          this.tabela.status = ''
        }

        // SETA O TIME PARA FORÇA A ATUALIZAÇÃO DO COMPONENT
        this.time = new Date().getTime()
      },
      // FUNÇÕES PARA EDITAR VALORES DENTRO DA TABELA
      // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
      onChangeValueTabela: function (id, field, value) {
        // PROCURA QUAL É O REGISTRO QUE ESTA SENDO ALTERADO
        var index = this.tabela.linha.findIndex(item => item.DocModelo.toString() === id.toString())

        // ATUALIZA O VALOR NO REGISTRO SOLICITADO
        this.tabela.linha[index][field].value = value

        // SETA O TIME PARA FORÇA A ATUALIZAÇÃO DO COMPONENT
        this.time = new Date().getTime()
      },
      montaPutCadastroServico: function (aCheckbox) {
        var aFormEnvia = []

        var passou = false

        for (var key1 in this.tabela.linha) {
          if (this.tabela.linha[key1].editavel === true) {
            // SETA QUE TEM CAMPOS PARA ATUALIZAR
            passou = true

            // CRIA O FORMULARIO DE EDIÇÃO DESTE REGISTRO
            var formEnvia = {}

            // SETA O MODELO QUE ESTA SENDO EDITADO
            formEnvia.doc_modelo = this.tabela.linha[key1].DocModelo

            // SETA O NUMERO QUE FOI PREENCHIDO
            formEnvia.doc_numero = this.tabela.linha[key1].DocNumero.value

            // SETA A SERIE QUE FOI PREENCHIDO
            formEnvia.doc_serie = this.tabela.linha[key1].DocSerie.value

            // ADICIONA O VALOR AO FORMULARIO
            aFormEnvia.push(formEnvia)
          }
        }

        if (passou === true) {
          this.putCadastro(aFormEnvia)
        } else {
          // SETA A NOVA DATA PARA FORÇAR A ATUALIZAÇÃO DOS COMPONENTS
          this.time = new Date().getTime().toString()
        }
      },
      putCadastro: function (aFormEnvia) {
        var self = this

        // self.countRetorno = 0

        for (var key in aFormEnvia) {
          // self.$store.state.comunicaAPI(self.retCadastro, '/df/config', null, 'PUT', aFormEnvia[key], { numRetornos: aFormEnvia.length, idRegstro: aFormEnvia[key].doc_modelo })

          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          self.$store.state.comunicaAPI('/df/config', 'PUT', aFormEnvia[key], function (apiSuccess) {
            self.countRetorno = self.countRetorno + 1

            self.$store.state.msgWarn(apiSuccess, 'success')

            // if (array.numRetornos === self.countRetorno) {
            //   self.time = new Date().getTime()

            //   self.iniciarTabela()
            // }
          }, function (apiError) {
          })
        }
      }
      // retCadastro: function (aRet, array) {
      //   if (aRet.hasOwnProperty('aCod') && aRet.aCod === '100') {
      //     this.countRetorno = this.countRetorno + 1

      //     this.$store.state.msgWarn(aRet.aVet, 'success')

      //     if (array.numRetornos === this.countRetorno) {
      //       this.time = new Date().getTime()

      //       this.iniciarTabela()
      //     }
      //   } else if (aRet.hasOwnProperty('aCod') && aRet.aCod === '32') {
      //     // PROCURA QUAL É O REGISTRO QUE ESTA SENDO ALTERADO
      //     var index = this.tabela.linha.findIndex(item => item.DocModelo.toString() === array.idRegstro.toString())

      //     // REALIZA O FOR DOS ERROS RECEBIDOS
      //     for (var key1 in aRet.aErr) {
      //       // MONTA A MENSAGEM RECEBIDA PARA O CAMPO
      //       var mensagemErro = ''
      //       for (var key3 in aRet.aErr[key1]) {
      //         // PEGA OS VALORES E ADICONA UMA QUEBRA DE LINHA NO FINAL
      //         mensagemErro += aRet.aErr[key1][key3] + '<br/>'
      //       }
      //       // REMOVE A QUEBRA DE LINHA FINAL
      //       mensagemErro = mensagemErro.substring(0, (mensagemErro.length - ('<br/>'.length)))

      //       if (key1 === 'doc_numero') {
      //         this.tabela.linha[index]['DocNumero'].mensagem = mensagemErro
      //         this.tabela.linha[index]['DocNumero'].mensagemTipo = 'error'
      //       } else if (key1 === 'doc_serie') {
      //         this.tabela.linha[index]['DocSerie'].mensagem = mensagemErro
      //         this.tabela.linha[index]['DocSerie'].mensagemTipo = 'error'
      //       } else {
      //         this.$store.state.msgWarn(mensagemErro, 'danger')
      //       }
      //     }

      //     this.time = new Date().getTime()
      //   }
      // }
      */
    }
  }
</script>
